var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
// @ts-ignore no types
import Img from 'react-image';
import StackLayout from '../../../layouts/stackLayout/StackLayoutComponent';
function resolveResizeMode(resizeMode) {
    switch (resizeMode) {
        case 'center':
            return 'scale-down';
        case 'contain':
            return 'contain';
        case 'cover':
            return 'cover';
        case 'stretch':
            return 'fill';
        default:
            return 'cover';
    }
}
var ImageImplementation = function (props) {
    var placeholder = props.placeholder, uri = props.uri, customStyle = props.customStyle, resizeMode = props.resizeMode, alt = props.alt, className = props.className;
    var imageStyle = __assign({ position: 'absolute', height: '100%', width: '100%', objectFit: resolveResizeMode(resizeMode) }, customStyle);
    return (React.createElement(StackLayout, { customStyle: { overflow: 'hidden' }, className: className },
        placeholder ? (React.createElement(Img, { src: placeholder, style: imageStyle, alt: alt })) : null,
        React.createElement(Img, { src: uri, style: imageStyle, alt: alt })));
};
export default ImageImplementation;
//# sourceMappingURL=ImageImplementation.js.map